import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookieStorageService {

  constructor() { }

  // Method for get a cookie from browser - iterate over all the cookies to find the one with the specified name
	// name (string): indicates the cookie name to search and get the value
	public getCookie(name: string): string
	{
		const cookieName = `${name}=`;
		const decodedCookie = decodeURIComponent(document.cookie);
		const cookieArray = decodedCookie.split(';');

		for (let i = 0; i < cookieArray.length; i++) {
			let cookie = cookieArray[i];
			while (cookie.charAt(0) === ' ') {
			cookie = cookie.substring(1);
			}
			if (cookie.indexOf(cookieName) === 0) {
			return cookie.substring(cookieName.length, cookie.length);
			}
		}

		return '';
	}

	// Method for SET a cookie browser - store the cookie in the browser during X days
	// name (string): indicates the cookie name
	// daysToExpire (number): the time that the key should be valid
	public setCookie(name: string, value: string, daysToExpire?: number): void
	{
		let cookieString = `${name}=${value}`;

		if (daysToExpire) {
			const expirationDate = new Date();
			expirationDate.setDate(expirationDate.getDate() + daysToExpire);
			cookieString += `;expires=${expirationDate.toUTCString()};path=/`;
		}

		document.cookie = cookieString;
	}


	public removeCookie(name:string){
		document.cookie = `${name}= ; expires = Thu, 01 Jan 1970 00:00:00 GMT`
	}
}
